/*eslint react/no-deprecated:0*/
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col, Container } from 'reactstrap';

import ItemListC from './itemList';
import * as gruposActions from 'modules/grupos/action';
import * as generalActions from 'modules/general/action';
import { EliminarConfirmacionC } from 'modules/general/component';
import { checkPermissions } from 'core/generalFunctions';

moment.locale('es');

@connect(store => ({
  userRoles: store.getIn(['user', 'roles']),
  gruposList: store.getIn(['grupos', 'lista']),
  eliminarId: store.getIn(['grupos', 'eliminarId']),
}))
export default class extends React.Component {
  componentDidMount() {
    this.exitCopy = false;
    const { dispatch } = this.props;
    if (checkPermissions(['admin', 'administrador_grupos'])) {
      dispatch(gruposActions.get());
    }
    this.props.dispatch(generalActions.dashboard_changeTitle('GRUPOS'));
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userRoles && this.props.userRoles != nextProps.userRoles && checkPermissions(['admin', 'administrador_grupos'])) {
      this.props.dispatch(gruposActions.get());
    }
  }
  delete = grupo => this.props.dispatch(gruposActions.setState({ eliminarId: grupo ? grupo.id : false }));
  confirmDelete = () => {
    this.props.dispatch(gruposActions.delete_(this.props.eliminarId));
    this.delete();
  };
  add = () => this.props.dispatch(push('/dashboard/grupos/add/new'));
  crearSimilar = grupo => {
    this.exitCopy = true;
    this.props.dispatch(gruposActions.setState({ grupo }));
    this.props.dispatch(push('/dashboard/grupos/add/new'));
  };
  componentWillUnmount() {
    if (!this.exitCopy) this.props.dispatch(gruposActions.clear('lista'));
  }
  render() {
    const { gruposList } = this.props;
    return (
      <Container>
        <Col md={{ size: 8, offset: 2 }}>
          <MaterialUI.Paper zDepth={2} className="container">
            <Row>
              <Col md="12">
                <MaterialUI.List className="noPadding dividerList">
                  {gruposList && gruposList.map(grupo => <ItemListC key={grupo.get('id')} grupo={grupo.toJS()} delete={this.delete} crearSimilar={this.crearSimilar} />)}
                </MaterialUI.List>
              </Col>
            </Row>
          </MaterialUI.Paper>
        </Col>
        {checkPermissions(['admin', 'administrador_grupos']) && (
          <MaterialUI.FloatingActionButton className="bottonFlotanteAdd" onTouchTap={this.add}>
            <FontAwesome name="plus" />
          </MaterialUI.FloatingActionButton>
        )}
        <EliminarConfirmacionC eliminarId={this.props.eliminarId} confirmar={this.confirmDelete} cancelar={this.delete} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/grupos/components/main.js